import { TransportService, IBaseOption } from '@ql-midle/apollo-client';
import { BaseOption } from '@ql-midle/apollo-client';

/**
 * 通用参数
 */
interface IApiParams {
	url: string;
	method?: 'post' | 'get';
	body?: any;
}

/**
 * QA
 *
 * @class ServiceQA
 * @extends {TransportService}
 */
class ServiceQA extends TransportService {
	private store: any = null;

	constructor() {
		super(new BaseOption('QA'));
	}

	/**
	 * 覆写注册，添加store
	 */
	public register(params: any): void {
		this.registerSecurity(params);

		if (params.store) {
			this.store = params.store;
		}
	}

	/**
	 * 测试接口
	 *
	 * @returns {Promise<any>}
	 */
	public async commonApi(params: IApiParams): Promise<any> {
		const { url, method = 'post', body } = params;
		if (method === 'post') {
			return await this.post(url, body);
		} else {
			let query: string = '';
			if (typeof body === 'object') {
				for (let k in body) {
					if (!query) {
						query += `?${k}=${body[k]}`;
					} else {
						query += `&${k}=${body[k]}`;
					}
				}
			}

			return await this.get(url + query);
		}
	}
}

export default new ServiceQA();
